// extracted by mini-css-extract-plugin
export default {"list":"index_list_36eCc","img":"index_img_AuSW3"};